import React from "react";

const List = () => {
    return <div>공지사항 리스트</div>;
};

export default List;
